import {appsumoService} from '../index'

class Appsumo {
    checkActivation = token => appsumoService.get('activation', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export default new Appsumo()
